/**
 * @typedef {Object} ClientLoginLocationViewModelType
 * @property {number} locationId - The ID of the location.
 * @property {string} locationName - The name of the location.
 * @property {number} clientId - The ID of the client.
 * @property {string} clientName - The name of the client.
 * @property {number} clientTypeInt - The integer representation of the client type.
 * @property {number} clientGroupId - The ID of the client group.
 * @property {string} clientGroupName - The name of the client group.
 * @property {string} startTime - The start time of operations.
 * @property {string} endTime - The end time of operations.
 * @property {number} locationLunchBreakMinutes - The duration of the lunch break in minutes.
 * @property {boolean} submittedByTemplateRequired - Indicates if submission by template is required.
 * @property {string} addressLine1 - The first line of the address.
 * @property {string} addressLine2 - The second line of the address.
 * @property {string} suburb - The suburb of the location.
 * @property {string} postcode - The postcode of the location.
 * @property {string} state - The state of the location.
 * @property {string} country - The country of the location.
 * @property {string} timeZone - The timezone of the location.
 * @property {string} purchaseOrderNumber - The purchase order number stored on client.
 */

export default class ClientLoginLocationViewModel {
  /** @param {ClientLoginLocationViewModelType} params */
  constructor(params) {
    this.locationId = params.locationId
    this.locationName = params.locationName
    this.clientId = params.clientId
    this.clientName = params.clientName
    this.clientTypeInt = params.clientTypeInt
    this.clientGroupId = params.clientGroupId
    this.clientGroupName = params.clientGroupName
    this.startTime = params.startTime
    this.endTime = params.endTime
    this.locationLunchBreakMinutes = params.locationLunchBreakMinutes
    this.submittedByTemplateRequired = params.submittedByTemplateRequired
    this.addressLine1 = params.addressLine1
    this.addressLine2 = params.addressLine2
    this.suburb = params.suburb
    this.postcode = params.postcode
    this.state = params.state
    this.country = params.country
    this.timeZone = params.timeZone
    this.purchaseOrderNumber = params.purchaseOrderNumber
  }
}
